import { getAnalytics } from "@tm/insurance/analytics";
import { trackComponentView, trackEvent } from "@tm/insurance/analytics/xdm";
import { FlexComp, H2Tag, H5Tag } from "@tm/static";
import { usePartnerContext } from "@tm/static/partnerContext";
import { usePlanType } from "@tm/ui";
import { useEffect, useState } from "react";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { InnerContentWrap } from "../../CommonStyle/CommonStyles.style";
import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";
import {
  ExclusiveOffersStyle,
  OffersWrap,
  SliderArrowLeft,
  SliderArrowRight,
  SliderContainer,
  SliderWrap,
  SlidesBtnWrap,
} from "./ExclusiveOffers.style";
import OfferItem from "./OfferItem";

interface ExclusiveOfferProp {
  data: {
    title: TextNodeType;
    items: {
      cta: {
        url: string;
        type: string;
      };
      image_url: string;
    }[];
  };
  bgColor?: string;
  padding?: string;
}

const analytics = getAnalytics();

const ExclusiveOffers = ({ data, bgColor, padding }: ExclusiveOfferProp) => {
  const device = useBreakpoint();
  const [currentSlide, setCurrentSlide] = useState(0);
  const { type } = usePlanType();
  const context = usePartnerContext();

  const handleNext = () => {
    if (currentSlide < data.items.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };
  const handlePrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  useEffect(() => {
    data.items.forEach((item, index) => {
      const element = document.getElementById(`slide${index}`);
      const observer = new IntersectionObserver(obCallback, {
        threshold: 1,
      });
      element && observer.observe(element);
      function obCallback(entries: any) {
        if (entries[0].isIntersecting) {
          analytics?.trackLandingEvents(
            {
              actionType: `offer_banner${index + 1}_shown`,
            },
            "pageView",
            type
          );
          trackComponentView({
            name: `offer_banner_${index + 1}_shown`,
            type: "offers",
          });
        }
      }
    });
  }, [data.items]);

  const handleClickOfferItem = (index: number) => {
    analytics?.trackLandingEvents(
      {
        actionType: `offer_banner${index + 1}_clicked`,
      },
      "pageView",
      type
    );
    trackEvent({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `offer_banner_${index + 1}_clicked`,
      },
    });
  };

  return (
    <ExclusiveOffersStyle bgColor={bgColor} padding={padding}>
      <InnerContentWrap>
        {device == "lg" ? (
          <FlexComp
            margin="0 0 60px"
            alignItems="center"
            justifyContent="space-between"
          >
            <H2Tag>{data.title && <FormattedText value={data.title} />}</H2Tag>
            <SlidesBtnWrap>
              <SliderArrowLeft
                disable={currentSlide == 0}
                onClick={handlePrev}
              ></SliderArrowLeft>
              <SliderArrowRight
                disable={currentSlide == data.items.length - 1}
                onClick={handleNext}
              ></SliderArrowRight>
            </SlidesBtnWrap>
          </FlexComp>
        ) : (
          <H5Tag margin="0 0 20px">
            {data.title && <FormattedText value={data.title} />}
          </H5Tag>
        )}
        {device == "sm" && (
          <OffersWrap>
            {data.items &&
              data.items.map((item, index: number) => {
                return (
                  <div id={`slide${index}`} key={index}>
                    <OfferItem
                      handleClickOfferItem={() => handleClickOfferItem(index)}
                      cta={item.cta}
                      image_url={item.image_url}
                      offerItemLength={data.items.length}
                    />
                  </div>
                );
              })}
          </OffersWrap>
        )}
        {device == "lg" && (
          <SliderContainer>
            <SliderWrap
              style={{
                transform: `translateX(-${currentSlide * 42}%)`,
                transition: "transform 0.5s ease-in-out",
              }}
            >
              {data.items &&
                data.items.map((item, index: number) => {
                  return (
                    <div
                      id={`slide${index}`}
                      style={{ marginRight: 20 }}
                      key={index}
                    >
                      <OfferItem
                        handleClickOfferItem={() => handleClickOfferItem(index)}
                        cta={item.cta}
                        image_url={item.image_url}
                      />
                    </div>
                  );
                })}
            </SliderWrap>
          </SliderContainer>
        )}
      </InnerContentWrap>
    </ExclusiveOffersStyle>
  );
};

export default ExclusiveOffers;
